import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	NgZone,
	ViewRef
}
from '@angular/core';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-service-page/phieu-thong-tin-hang-ve.service';
import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DeNghiNhapKhoChiTiet, DenghinhapkhoLsthaotac } from '../phieu-thong-tin-hang-ve-model-page/phieu-thong-tin-hang-ve.model';

@Component({
	selector: 'm-thong-tin-duyet-detail-dialog',
	templateUrl: './thong-tin-duyet-detail-dialog.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class ThongTinDuyetDialogComponent implements OnInit{

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* ------------------- Các form trên dialog --------------------------*/
	ThongTinHangVeCTForm: FormGroup;				
	KiemTraPassHangForm: FormGroup;
	TPDuyetForm: FormGroup;
	GDDuyetForm: FormGroup;
	/* ------------------------------------------------------------------ */

	/*-------------------- Mat select search cho kho ---------------------*/
	listKho : any[] = [];
	selectedKho : string = '';
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	thongTinHangVeCTItem: DeNghiNhapKhoChiTiet;
	thongTinHangVeLSList: DenghinhapkhoLsthaotac[] = [];
	/* ------------------------------------------------------------------ */

	/*------------------------- Extend field: ----------------------------*/
	title: string = '';	
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.	
	previousIndex: number; 				 // Lưu lại vị trí trước đó khi swap các cột trên lưới
	saveAdded: number[] = []		     // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	 // Loading khi mở dialog
	listOptionKetQua: any[]
	disableButton: boolean = false;
	isChange: boolean = false;	
	isDisableSLPH: boolean = false;
	tmpListOptionKetQua: any[] = []
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<ThongTinDuyetDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private dungChungService : DungChungService,
		private ThongTinHangVeCTFB: FormBuilder,
		private KiemTraPassHangFB: FormBuilder,
		private TPDuyetFB: FormBuilder,
		private GDDuyetFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
	) {
		this.dialogRef.disableClose = true;
	}


	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		/*Get data from list when open dialog */
		this.thongTinHangVeCTItem = this.data.data;
		this.listOptionKetQua = DeNghiNhapKhoChiTiet.optionQuyetDinhLoHangChange;
		this.thongTinHangVeLSList = this.data.ls;
		
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Load all dropdown and create form */
		this.createForm();
		this.ListKho();
		this.title = this.getTitle();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});

		this.changeDetectView();
	}
	getTrangThaiDetail(state: string){
		let item = DeNghiNhapKhoChiTiet.optionTrangThaiDetail.find(x => x.value == state)
		if(item != null){
			return item.name;
		}
		return '';
	}
	getTitle(): string {
		return `Thông tin pass hàng`;
	}
	getHistory(idDetail: any, type: number){
		let item = this.thongTinHangVeLSList.find(x => x.DeNghiNhapKhoCtId == idDetail 
												&& x.LoaiThaoTac == DeNghiNhapKhoChiTiet.optionTrangThaiDetail[3].value)
	
		if(item != null && type == 0){
			return item.NoiDung
		}
		else if(item != null && type == 1){
			return item.GhiChu;
		}
		else if(item != null && type == 2){
			return item.TenNguoiThaoTac;
		}
		else if(item != null && type == 3){
			return item.NgayThaoTac;
		}
		return '';
	}
	getHistoryHT(idDetail: any, type: number){
		let item = this.thongTinHangVeLSList.find(x => x.DeNghiNhapKhoCtId == idDetail 
										&& x.LoaiThaoTac == DeNghiNhapKhoChiTiet.optionTrangThaiDetail[4].value)
	
		if(item != null && type == 0){
			return item.NoiDung
		}
		else if(item != null && type == 1){
			return item.GhiChu;
		}
		else if(item != null && type == 2){
			return item.TenNguoiThaoTac;
		}
		else if(item != null && type == 3){
			return item.NgayThaoTac;
		}
		return '';
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form and handle event on form -----------------*/
	createForm(){
		/*Group các Form */
		this.ThongTinHangVeCTForm = this.ThongTinHangVeCTFB.group({
			MaHH: [this.thongTinHangVeCTItem.MaHH],
			TenHH: [this.thongTinHangVeCTItem.TenHH],
			QuyCach: [this.thongTinHangVeCTItem.QuyCach],
			TenDVT: [this.thongTinHangVeCTItem.TenDVT],
			SLKehoach: [this.f_number((this.thongTinHangVeCTItem.Soluongkehoach))],
			SLThucGiao: [this.f_number((this.thongTinHangVeCTItem.SoLuongThucGiao))],
			SoLo: [this.thongTinHangVeCTItem.Solo],
			TrangThaiPassHang: [this.getTrangThaiDetail(this.thongTinHangVeCTItem.TrangThaiPassHang)],
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.ThongTinHangVeCTForm.disable();
	
		this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
			NguoiKiemTra: [this.thongTinHangVeCTItem.TenNguoiKiemTra],
            NgayKiemTra:  [this.getFormatDate(this.thongTinHangVeCTItem.Ngaykiemtra)],
			QuyetDinhTra: [this.thongTinHangVeCTItem.QuyetDinhTra + ''],
		});
	
		var tenNguoiLap = '';
        this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

		this.TPDuyetForm = this.TPDuyetFB.group({
            NguoiXacNhan: [this.getHistory(this.thongTinHangVeCTItem.IdCtdn,2)],
            NgayXacNhan: [this.getFormatDate(this.getHistory(this.thongTinHangVeCTItem.IdCtdn,3))],
			KetQUaDuyet: [this.getHistory(this.thongTinHangVeCTItem.IdCtdn,0)],
			LyDo: [this.getHistory(this.thongTinHangVeCTItem.IdCtdn,1)]
		})

		/*Disable các trường dữ liệu không thay đổi */
		this.TPDuyetForm.disable();

		this.GDDuyetForm = this.GDDuyetFB.group({
            NguoiXacNhan: [this.getHistoryHT(this.thongTinHangVeCTItem.IdCtdn,2)],
            NgayXacNhan: [this.getFormatDate(this.getHistoryHT(this.thongTinHangVeCTItem.IdCtdn,3))],
			KetQUaDuyet: [this.getHistoryHT(this.thongTinHangVeCTItem.IdCtdn,0)],
			LyDo: [this.getHistoryHT(this.thongTinHangVeCTItem.IdCtdn,1)]
		})

		/*Disable các trường dữ liệu không thay đổi */
		this.GDDuyetForm.disable();

		this.changeQuyetDinhTra();
		this.KiemTraPassHangForm.disable();
		this.changeDetectView();
	}

	changeQuyetDinhTra(){
		
		if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == this.listOptionKetQua[0].value){
			this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
				NguoiKiemTra: [this.thongTinHangVeCTItem.TenNguoiKiemTra],
				NgayKiemTra: [this.getFormatDate(this.thongTinHangVeCTItem.Ngaykiemtra)],
				QuyetDinhTra: [this.listOptionKetQua[0].value.toString()],

				KhoPhuhop: [(this.thongTinHangVeCTItem.KhoPhuHop) + ''],
				SoLuongPhuHop:[this.f_number(this.thongTinHangVeCTItem.SoLuongPhuHop)],

				KhoKhongPhuHop: [(this.thongTinHangVeCTItem.KhoKhongPhuHop) + ''],
				SoLuongKhongPhuHop:[this.f_number(this.thongTinHangVeCTItem.SoLuongKhongPhuHop)],
			});
		}
		else if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == this.listOptionKetQua[2].value){
			this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
				NguoiKiemTra: [this.thongTinHangVeCTItem.TenNguoiKiemTra],
				NgayKiemTra: [this.getFormatDate(this.thongTinHangVeCTItem.Ngaykiemtra)],
				QuyetDinhTra: [this.listOptionKetQua[2].value.toString()],

				LyDoTra: [this.thongTinHangVeCTItem.GhiChuKetQuaKiemTra],
			});
		}
		else if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == this.listOptionKetQua[3].value){
			this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
				NguoiKiemTra: [this.thongTinHangVeCTItem.TenNguoiKiemTra],
				NgayKiemTra: [this.getFormatDate(this.thongTinHangVeCTItem.Ngaykiemtra)],
				QuyetDinhTra: [this.listOptionKetQua[3].value.toString()],

				KhoiLuongTra: [this.f_number(this.thongTinHangVeCTItem.SoLuongTraHang)],
				KhoiLuongNhap: [DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE],
				LyDoTra: [this.thongTinHangVeCTItem.GhiChuKetQuaKiemTra],

				KhoPhuhop: [(this.thongTinHangVeCTItem.KhoPhuHop) + ''],
				SoLuongPhuHop:[this.f_number(this.thongTinHangVeCTItem.SoLuongPhuHop)],

				KhoKhongPhuHop: [(this.thongTinHangVeCTItem.KhoKhongPhuHop) + ''],
				SoLuongKhongPhuHop:[this.f_number(this.thongTinHangVeCTItem.SoLuongKhongPhuHop)],
			});
			this.changeSLEvent(this.listOptionKetQua[3].value, -1)
		}
		else if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == this.listOptionKetQua[4].value){
			this.KiemTraPassHangForm = this.ThongTinHangVeCTFB.group({
				NguoiKiemTra: [this.thongTinHangVeCTItem.TenNguoiKiemTra],
				NgayKiemTra: [this.getFormatDate(this.thongTinHangVeCTItem.Ngaykiemtra)],
				QuyetDinhTra: [this.listOptionKetQua[4].value.toString(),Validators.required],

				KhoiLuongTra: [this.f_number(this.thongTinHangVeCTItem.SoLuongTraHang)],
				KhoiLuongTamNhap: [DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE],
				LyDoTra: [this.thongTinHangVeCTItem.GhiChuKetQuaKiemTra],
			});
			this.changeSLEvent(this.listOptionKetQua[4].value, -1)
		}
		this.changeDetectView();
	}
	changeSLEvent(type: number, subType: number){
		switch(type){
			case this.listOptionKetQua[0].value:
				var max = +this.f_number(this.ThongTinHangVeCTForm.controls["SLThucGiao"].value)
				this.changePH_KPH(max, subType);
				break;
			case this.listOptionKetQua[3].value:
				this.changeKLNhap();
				if(subType !=  -1){
					var max = +this.f_number(this.KiemTraPassHangForm.controls["KhoiLuongNhap"].value)
					this.changePH_KPH(max, subType);
				}
				break;
			case this.listOptionKetQua[4].value:
				this.changeKLTamNhap();
				break;
		}
	}
	private changePH_KPH(max: number, subType: number){
		var PH = +this.f_number(this.KiemTraPassHangForm.controls["SoLuongPhuHop"].value)
		var KPH = +this.f_number(this.KiemTraPassHangForm.controls["SoLuongKhongPhuHop"].value)
		if(PH > max){
			this.KiemTraPassHangForm.controls["SoLuongPhuHop"].setValue(this.f_number(max));
			this.KiemTraPassHangForm.controls["SoLuongKhongPhuHop"].setValue(this.f_number(0));
		}
		else if(KPH > max){
			this.KiemTraPassHangForm.controls["SoLuongKhongPhuHop"].setValue(this.f_number(max));
			this.KiemTraPassHangForm.controls["SoLuongPhuHop"].setValue(this.f_number(0));
		}
		else{
			if(subType == 0){
				KPH = max - PH;
				this.KiemTraPassHangForm.controls["SoLuongPhuHop"].setValue(this.f_number(PH));
				this.KiemTraPassHangForm.controls["SoLuongKhongPhuHop"].setValue(this.f_number(KPH));
			}
			else{
				PH = max - KPH;
				this.KiemTraPassHangForm.controls["SoLuongPhuHop"].setValue(this.f_number(PH));
				this.KiemTraPassHangForm.controls["SoLuongKhongPhuHop"].setValue(this.f_number(KPH));
			}
		}
		this.changeDetectView();
	}
	private changeKLNhap(){
		var KLTra = this.f_number(this.KiemTraPassHangForm.controls["KhoiLuongTra"].value)
		if(KLTra != null){
			var KLNhap = +this.f_number(this.ThongTinHangVeCTForm.controls["SLThucGiao"].value) - +KLTra;
			if(KLNhap >= 0)
				this.KiemTraPassHangForm.controls["KhoiLuongNhap"].setValue(this.f_number(KLNhap));
			else
				this.KiemTraPassHangForm.controls["KhoiLuongNhap"].setValue(this.f_number(0));
		}
		this.changeDetectView();
	}
	private changeKLTamNhap(){
		var KLTra = this.f_number(this.KiemTraPassHangForm.controls["KhoiLuongTra"].value)
		if(KLTra != null){
			var KLNhap = +this.f_number(this.ThongTinHangVeCTForm.controls["SLThucGiao"].value) - +KLTra;
			if(KLNhap >= 0)
				this.KiemTraPassHangForm.controls["KhoiLuongTamNhap"].setValue(this.f_number(KLNhap));
			else
				this.KiemTraPassHangForm.controls["KhoiLuongTamNhap"].setValue(this.f_number(0));
		}
		this.changeDetectView();
	}
	
	isWarningKho(type: number){
		switch(type){
			case 0:
				return this.f_number(this.KiemTraPassHangForm.controls['SoLuongPhuHop'].value) > 0
							&& (this.KiemTraPassHangForm.controls['KhoPhuhop'].value == '' || 
							this.KiemTraPassHangForm.controls['KhoPhuhop'].value == null)
			case 1:
				return this.f_number(this.KiemTraPassHangForm.controls['SoLuongKhongPhuHop'].value) > 0
							&& (this.KiemTraPassHangForm.controls['KhoKhongPhuHop'].value == '' || 
							this.KiemTraPassHangForm.controls['KhoKhongPhuHop'].value == null)
		}
		return false;
	}
	isWarningSLTra1Phan(){
		return +this.f_number(this.KiemTraPassHangForm.controls['KhoiLuongTra'].value) >= 
			+this.f_number(this.ThongTinHangVeCTForm.controls["SLThucGiao"].value)
	}
	/* -----------------------------------------------------------------------*/

	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListKho(){
		this.dungChungService.listKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKho = res.data;
				this.filteredKho.next(this.listKho.slice());
				this.changeDetectView();
			};
		});
	}
	filterKho() {
		if (!this.listKho) {
			return;
		}
		let search = this.KhoFilterCtrl;
		if (!search) {
			this.filteredKho.next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKho.next(
			this.listKho.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputTSL(){
		let message = "";
		let controls = this.KiemTraPassHangForm.controls;
		var SLTG = +this.f_number(this.ThongTinHangVeCTForm.controls["SLThucGiao"].value)
		var SLKH = +this.f_number(this.ThongTinHangVeCTForm.controls["SLKehoach"].value)

		if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == 0){
			var SLPH = +this.f_number(controls["SoLuongPhuHop"].value)
			var SLKPH = +this.f_number(controls["SoLuongKhongPhuHop"].value)

			//Thay đổi theo yêu cầu triển khai ngày 16-01-2021 => chỉ nhỏ hơn số lượng hàng về
			if(((SLPH + SLKPH) > SLTG)){
			 	return 'Tổng số lượng phù hợp và số lượng không phù hợp không được lớn hơn số lượng hàng về';
			}
		}
		else if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == 1
			&& +this.KiemTraPassHangForm.controls["QuyetDinhLoHang"].value == 0){
			var SLPH = +this.f_number(controls["SoLuongPhuHop"].value)
			var SLKPH = +this.f_number(controls["SoLuongKhongPhuHop"].value)
			var SLT = +this.f_number(controls["SoLuongTra"].value)

			//Thay đổi theo yêu cầu triển khai ngày 16-01-2021 => chỉ nhỏ hơn số lượng hàng về
			if(((SLPH + SLKPH + SLT) > SLTG)){
				return 'Tổng số lượng phù hợp, không phù hợp và trả hàng không được lớn hơn số lượng hàng về';
		   }
		}
		else if(+this.KiemTraPassHangForm.controls["QuyetDinhTra"].value == 1
			&& +this.KiemTraPassHangForm.controls["QuyetDinhLoHang"].value == 1){

			var SLT = +this.f_number(controls["SoLuongTra"].value)
			//Thay đổi theo yêu cầu triển khai ngày 16-01-2021 => chỉ nhỏ hơn số lượng hàng về
			if(((SLT) > SLTG)){
					return 'Số lượng trả hàng không được lớn hơn số lượng hàng về';
			}
		}
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
        if (v != null && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/

	
	/*---------------------------- Thao tác trên form ------------------------*/
	back() {
		this.dialogRef.close(
			{ isChange: this.isChange,}
		);
	}
	/* -----------------------------------------------------------------------*/
	

	/*------------------------------ Extend Options --------------------------*/
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/
}